import Marionette from 'backbone.marionette';
import queryString from 'query-string';
import LoginView from '../../views/Login';
import { LoginOldView, Error404View } from '../../../../core/views';
import { HomeView } from '../../views';
import { AdvertisingView } from '../../views';
import { sizes_for_big_ad } from '../../../../core/utils';
import Radio from "backbone.radio";
import News from "../../collections/News";
import Backbone from "backbone";

const channelUserModals = Radio.channel( 'userModals' );

export default class HomeController extends Marionette.Object {
	async home() {

		// Get url params
		const params = queryString.parse(location.search);
		let homeView;

		// If authorisation code has been passed into params, trigger login via Fanhub API
		if (params.code) {
			homeView = new LoginView({
				nrl_account_code: params.code,
				redirect_uri: params.state
			});
		}
		else {
			homeView = new HomeView({
				news: new News()
			});
		}

		const rootView = this.getOption( 'rootView' );
		this.initAdvertisings( rootView );
		rootView.getRegion( 'main' ).show( homeView );


		if (params.returning === 'true') {
			channelUserModals.trigger('show:activation:modal');
			Backbone.history.navigate('/', { trigger: false });
		}

	}

	oldHome() {
		const rootView = this.getOption( 'rootView' );
		rootView.getRegion( 'main' ).show(new LoginOldView());
	}

	registration() {
		console.log( 'Registration page' );
	}

	notFound() {
		const rootView = this.getOption( 'rootView' );
		rootView.getRegion( 'main' ).show(new Error404View);
	}
	initAdvertisings( rootView ) {
		const advertisingTop  = new AdvertisingView({
			ad_id: 'help-ad-slot-3',
			ad_path:'help',
			size: sizes_for_big_ad(),
			pos: 1,
		});
		rootView.getRegion( 'top_ads_container' ).show( advertisingTop );
	}
}